
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g_45DE6HZ03bHorBho6BcuOviMQxrZVHWhqKntNVGAY2DQMeta } from "/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexe03BD_45rgaYq2E_q20wh2QUGkwODYMXVHxvQ1o9rs4lQMeta } from "/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search_BHiIkx9_45js5hHwG_45Q3a2p_45ZYeP8TgZwmbdWFr4uxVEMeta } from "/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexX08pPDbY7kMVwqVJ84kwm_7AHUd0sYSz0T9jF3g5ssUMeta } from "/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93RS2mfU_KIoExqk5RWYEkoSr6HhwmLnPfE9YTMOzf6B0Meta } from "/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexWo5sjNjv2QEtSw6zKAjBbquHsWyoQ21DXJb9m2ZRM_45YMeta } from "/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_9342zDnSmVCqccGDRKk9XH90hCzk2_45tnqI54TnZieL_45noMeta } from "/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexh4ITxC1OJQTWr2pAbWxIQ6fZPJhnDn97OgD7wV2KqZIMeta } from "/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93vdLVf7OqbgWKXeGeXcMN9Yl8aAwiV6oLwPX3O8yfk0UMeta } from "/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index_7cLsF_45Gx9pSEU44HPBSliK3esaYkOFuhn54GPD7rHUMeta } from "/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexB0pLv09g7EvjCEktCVGIr5U80UAIWqpyXJB_PX3jOo4Meta } from "/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexWo5sjNjv2QEtSw6zKAjBbquHsWyoQ21DXJb9m2ZRM_45YMeta || {},
    component: () => import("/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexh4ITxC1OJQTWr2pAbWxIQ6fZPJhnDn97OgD7wV2KqZIMeta || {},
    component: () => import("/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index_7cLsF_45Gx9pSEU44HPBSliK3esaYkOFuhn54GPD7rHUMeta || {},
    component: () => import("/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexB0pLv09g7EvjCEktCVGIr5U80UAIWqpyXJB_PX3jOo4Meta || {},
    component: () => import("/codebuild/output/src1966883249/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]